class LqdFullscreenProjectHandler extends elementorModules.frontend.handlers.Base {

  onInit(...args) {

    super.onInit(...args);

    this.handleDestroy();

    this.initActiveOnHover();

  }

  getDefaultSettings() {
    return {
      selectors: {
        activeOnHoverEl: '[data-active-onhover]',
      }
    }
  }

  getDefaultElements() {
    const selectors = this.getSettings('selectors');
    return {
      $activeOnHoverEl: this.$element.find(selectors.activeOnHoverEl),
    }
  }

  initActiveOnHover() {

    this.elements.$activeOnHoverEl.liquidSetActiveOnhover();

  }

  onDestroy() {

    this.handleDestroy();

    super.onDestroy();

  }

  handleDestroy() {

    this.handleActiveOnHoverDestroy();

  }

  handleActiveOnHoverDestroy() {

    if ( ! this.elements.$activeOnHoverEl.length ) return;

    const activeOnHoverData = this.elements.$activeOnHoverEl.data('plugin_liquidSetActiveOnhover');

    if ( activeOnHoverData ) {
      activeOnHoverData.destroy();
    }

  }
  
}

export default ($element) => {
  elementorFrontend.elementsHandler.addHandler( LqdFullscreenProjectHandler, { $element } );
};